import { Injectable } from '@angular/core'
import { Router } from '@angular/router'
import { CoreService } from './core.service'

@Injectable({
  providedIn: 'root',
})
export class LogoutService {
  constructor(
    private readonly core: CoreService,
    private readonly router: Router
  ) {}

  async logout(): Promise<void> {
    if (this.router.url !== '/home') {
      const navigated = await this.router.navigate(['/home'], { replaceUrl: true })
      if (!navigated) {
        return
      }
    }

    this.core.services.oauth.logout()
  }
}
